// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36nJy","toggle":"styles_toggle__21M4O","preview":"styles_preview__1BNK_"};